export const OrderPaymentMethods = {
  CASHIER: "CASHIER",
  NONE: "NONE",
  PAYHERE: "PAYHERE",
};

export const PayoutsStartDate = new Date("2023-01-01");

export const PayoutStatuses = {
  INITIALIZED: "INITIALIZED",
  PAID: "PAID",
};

export const ModifierTypes = {
  SINGLE_CHOICE: "SINGLE_CHOICE",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
};

export const SubscriptionStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
};

export const PaymentModes = {
  PRODUCTION: "PROD",
  SANDBOX: "SANDBOX",
};

export const Panels = {
  CASHIER: "CASHIER",
  ADMIN: "ADMIN",
  SALES: "SALES",
  SUMMARY: "SUMMARY",
  PAYOUTS: "PAYOUTS",
  SUBSCRIPTIONS: "SUBSCRIPTIONS",
  KITCHEN: "KITCHEN",
};

export const PaymentMethods = {
  CASHIER: "CASHIER",
  IN_APP: "IN_APP",
};
